import * as React from "react";
import ObAssetsDetl from "../../instruments/details/obAssetsDetl";
import EdButton from "../../../../generic/edButton";
import Tab from "../../../../generic/tab";
import { IListObj } from "../../../../types/genericTypes";
import moment from "moment";
import { ObAssetsDetlProps } from "../../instruments/details/obAssetsDetl";
import ObIpoDtlsContent from "./obIpoDtlsContent";
import { ChipStatusComb } from "../../obConstants";
import "../../../../../assets/scss/components/toc/orderBook/obModifyState/obModify.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetails.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailstab.scss";

export interface IObIpoDtlsDskProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObIpoDtlsDsk: React.FC<IObIpoDtlsDskProps> = (props) => {
	const backButtonValue = (
		<>
			<i className="arrow_left edel-icon-arrow-left vTextTop" />
			<span>Back</span>
		</>
	);
	const tabLst: Array<IListObj> = [{ value: "info", display: "Info" }];
	const assetDetail: ObAssetsDetlProps = {
		date: props.data.submitDt ? moment(new Date(props.data.submitDt)).format("D MMM YYYY, HH:mm:ss") : "",
		trsTyp: "BUY",
		title: props.data.ipoNm,
		sts: ChipStatusComb[props.data.sts.toLowerCase()]
	};
	return (
		<section className="ob_detail_container">
			<section className="ob_detail_wrapper">
				<section className="list_view">
					<div className="ly_list_view ">
						{/* left menu back button */}
						<div className="lv_menu bckBtnDiv ">
							<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
						</div>
					</div>
					<div className="ob_right_cont ly_right_cont">
						<div className="ob_detail_view">
							{/* header section */}
							<div className="dv_content">
								<div className="ob_header">
									<ObAssetsDetl {...assetDetail} />
									{/* when status is rejected will show below content */}
									{props.data.applStatus[0].progress === "Failed" && (
										<div className="rjct_reason">
											<p className="rsn_hd">Reason</p>
											<p className="rsn">{props.data.applStatus[0].text || props.data.applStatus[0].reason}</p>
										</div>
									)}
								</div>
								{/* detailed content */}
								<div>
									<Tab defaultValue={"info"} tabList={tabLst} onSelect={() => {}} position="left" />
									<div className={"info show"}>
										<ObIpoDtlsContent data={props.data} onCancelClick={props.onCancelClick} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</section>
		</section>
	);
};

export default ObIpoDtlsDsk;
